import React from 'react';

// סוגים שונים של טעינה
export const LoadingSpinner = ({ size = 'md', text = '', className = '' }) => {
  const sizeClasses = {
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <div className={`${sizeClasses[size]} relative`}>
        {/* כדור טניס מסתובב */}
        <div 
          className="absolute inset-0 rounded-full border-4 border-green-200"
          style={{ borderTopColor: '#22c55e', animation: 'spin 0.8s linear infinite' }}
        />
        <div 
          className="absolute inset-1 rounded-full border-2 border-blue-200"
          style={{ borderTopColor: '#3b82f6', animation: 'spin 1s linear infinite reverse' }}
        />
      </div>
      {text && <p className="text-gray-500 text-sm font-medium">{text}</p>}
    </div>
  );
};

// טעינת כרטיסים (Skeleton)
export const CardSkeleton = ({ count = 1 }) => {
  return (
    <div className="space-y-4">
      {[...Array(count)].map((_, i) => (
        <div 
          key={i} 
          className="bg-white/60 rounded-xl p-4 animate-pulse"
          style={{ animationDelay: `${i * 0.1}s` }}
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gray-200 rounded-full" />
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-200 rounded w-3/4" />
              <div className="h-3 bg-gray-200 rounded w-1/2" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

// טעינת טבלה (Skeleton)
export const TableSkeleton = ({ rows = 5, cols = 4 }) => {
  return (
    <div className="space-y-2">
      {[...Array(rows)].map((_, i) => (
        <div 
          key={i} 
          className="flex gap-4 p-3 bg-white/40 rounded-lg animate-pulse"
          style={{ animationDelay: `${i * 0.05}s` }}
        >
          {[...Array(cols)].map((_, j) => (
            <div 
              key={j} 
              className="h-4 bg-gray-200 rounded flex-1"
              style={{ width: j === 0 ? '60px' : 'auto' }}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

// טעינת דף מלא
export const PageLoader = ({ text = 'טוען...' }) => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-blue-50/80 via-white/80 to-green-50/80 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-white/90 rounded-2xl shadow-xl p-8 flex flex-col items-center gap-4">
        <div className="relative w-16 h-16">
          <div 
            className="absolute inset-0 rounded-full border-4 border-green-100"
            style={{ borderTopColor: '#22c55e', animation: 'spin 0.7s linear infinite' }}
          />
          <div className="absolute inset-3 flex items-center justify-center">
            <span className="text-2xl">🎾</span>
          </div>
        </div>
        <p className="text-gray-600 font-medium">{text}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
